export class Plan {
  public PlanId = '';
  public PlanName = '';
  public PlanDescription = '';
  public PlanActive = false;
  public PlanPrice = '';
  public PlanType = '';
  public PlanFrequency = '';
  public PlanExpirationDate = '';
  public LoggedInUserHasPlan = false;

  constructor() { }

  public static parse(data: any): Plan {
    const plan = new Plan();

    if (data) {
      if (data.PlanId || data.PlanId) {
        plan.PlanId = data.PlanId || data.PlanId;
      }
      if (data.PlanName || data.PlanNombre) {
        plan.PlanName = data.PlanName || data.PlanNombre;
      }
      if (data.PlanDescription || data.PlanDescripcion) {
        plan.PlanDescription = data.PlanDescription || data.PlanDescripcion;
      }
      if (data.PlanActive || data.PlanActivo) {
        plan.PlanActive = data.PlanActive || data.PlanActivo;
      }
      if (data.PlanPrice || data.PlanPrecio) {
        plan.PlanPrice = data.PlanPrice || data.PlanPrecio;
      }
      if (data.PlanType || data.PlanTipo) {
        plan.PlanType = data.PlanType || data.PlanTipo;
      }
      if (data.PlanFrequency || data.PlanFrecuencia) {
        plan.PlanFrequency = data.PlanFrequency || data.PlanFrecuencia;
      }
      if (data.PlanExpirationDate || data.PlanVencimiento) {
        plan.PlanExpirationDate = data.PlanExpirationDate || data.PlanVencimiento;
      }
      if (data.LoggedInUserHasPlan) {
        plan.LoggedInUserHasPlan = data.LoggedInUserHasPlan;
      }
    }

    return plan;
  }
}
